function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Nearest-flight",
  transform: "translate(-548 -2074)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "mobile",
  transform: "translate(528 2056)"
}, /*#__PURE__*/React.createElement("g", {
  id: "top"
}, /*#__PURE__*/React.createElement("g", {
  id: "S7",
  transform: "translate(20 18)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#C4D600",
  cx: "12",
  cy: "12",
  r: "12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.396 5.754c-1.788 0-2.945.1-3.786.417-1.409.56-2.382 1.735-2.382 3.277 0 1.284.587 2.213 2.283 3.284 1.812 1.118 2.174 1.488 2.174 2.165 0 .736-.71 1.577-2.536 1.577-.637 0-1.597-.092-2.21-.244l-.292-.075A49.374 49.374 0 004 18.039l.29.088c.551.18 1.86.32 2.799.32 3.12 0 4.982-1.922 4.982-3.934 0-1.238-.55-2.178-2.413-3.362-.933-.585-1.409-.965-1.697-1.258a1.125 1.125 0 01-.26-.777c0-.23.048-.496.198-.69.16-.24.455-.394.855-.52.412-.139 1.173-.143 2.36-.143h1.104l.79-2.01h-1.612v.001zm8.346 0h-5.55l-.788 2.01h1.839c1.237 0 1.476-.028 1.787-.028-.449 1.047-3.154 8.07-3.154 8.07h2.289s3.423-8.743 3.786-9.66c.1-.205.053-.392-.21-.392z",
  id: "Shape",
  fill: "#FFF"
}))))))));